<template>
  <div>
    <v-btn
      @click="fetchAdminMovementReportGroupedByBranch"
      :disabled="isDisabled"
      color="primary"
      elevation="0"
    >
      <v-progress-circular v-if="isGeneratingReportGroupedByBranch" :size="14" :width="2" color="grey lighten-1" class="mr-2" indeterminate />
      <v-icon v-else left>mdi-download-box-outline</v-icon>
      <span class="d-none d-md-flex body-2">
        {{ $t('movement.actions.movementExcel.generateExcelGroupedByBranch') }}
      </span>
    </v-btn>

    <v-btn
      @click="fetchAdminMovementReport"
      :disabled="isDisabled"
      color="primary"
      elevation="0"
      class="ml-3"
    >
      <v-progress-circular v-if="isGeneratingReport" :size="14" :width="2" color="grey lighten-1" class="mr-2" indeterminate />
      <v-icon v-else left>mdi-download-box-outline</v-icon>
      <span class="d-none d-md-flex body-2">
        {{ $t('movement.actions.movementExcel.generateExcel') }}
      </span>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

const MAX_REPORT_PERIOD_MONTHS = 6

export default {
  name: 'MovementHeaderActions',

  computed: {
    ...mapGetters(['filters', 'isGeneratingReport', 'isGeneratingReportGroupedByBranch']),

    hasValidDateRange() {
      const { realEstateId, startDate, endDate } = this.filters

      if (realEstateId) return true

      if (!startDate || !endDate) return false

      return moment(endDate).diff(moment(startDate), 'months') <= MAX_REPORT_PERIOD_MONTHS
    },

    isDisabled() {
      return this.isGeneratingReportGroupedByBranch || this.isGeneratingReport || !this.hasValidDateRange
    }
  },

  methods: {
    ...mapActions(['fetchAdminMovementReport', 'fetchAdminMovementReportGroupedByBranch'])
  }
}
</script>
